// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WalletOutlinedSvg from "@ant-design/icons-svg/es/asn/WalletOutlined";
import AntdIcon from '../components/AntdIcon';

var WalletOutlined = function WalletOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: WalletOutlinedSvg
  }));
};

WalletOutlined.displayName = 'WalletOutlined';
export default React.forwardRef(WalletOutlined);